const _ = require("lodash");
const { sortByDate } = require("../../utils/commonutils");
const { dentistTypes } = require("../../constants");


exports.geneRateEarningsArray = (providerPayByPractice) => {
    const earnings = providerPayByPractice && providerPayByPractice.data ? Object.keys(providerPayByPractice.data)
        .sort((a, b) => a < b ? -1 : 1)
        .map(iPracticeKey => providerPayByPractice.data[iPracticeKey])
        .map(iPractice => {
            const { financialNotes, price, customProviderRates, practiceDBName, practiceBcare, calendarList, practiceTotalPay, postBonus,
                procBasedPay, newBasePay, collectionList, financialNoteList, worked, schedules, practiceInfo, sumCollectionsTotalByDate,
                patientVisits, patientVisitsPerDay, monthlyBaseWorkDays, goxNonBillableCare, dataHyg, hygCollectionList, hygAbbrObj,
                tierBonusPayRecords, hynBillableCare, hygienistProductionMatchingProviderTreatments, isHybridContract, tedCollectionsPay } = iPractice;
            let { payDetailsList, goxList } = iPractice;
            goxList = sortByDate(goxList, 'dateOfService');
            payDetailsList = sortByDate(payDetailsList, 'date');

            return ({
                financialNotes, practiceDBName, care: price, practiceBcare, postBonus, procBasedPay, customProviderRates,
                newBasePay, practiceTotalPay, calendarList, payDetailsList, worked, schedules, financialNoteList,
                goxList, goxNonBillableCare, practiceInfo, patientVisits, patientVisitsPerDay, collectionList, monthlyBaseWorkDays, hygData: dataHyg, hygCollectionList,
                hygAbbrObj, sumCollectionsTotalByDate, tierBonusPayRecords, hynBillableCare, hygienistProductionMatchingProviderTreatments,
                isHybridContract, tedCollectionsPay
            })
        }) : [];
    return earnings;
}

const getCustomStyle = (drItem) => {
    return drItem['contractName'] === 'Sum Of'
        ? { background: 'primary', color: '#d67d38' } : drItem['contractName'] === 'Greater Of'
            ? { background: '#1a89a7' } : drItem['contractName'] === 'GOX'
                ? { background: 'green' } : drItem['contractName'] === 'GOZ'
                    ? { background: 'purple' } : drItem['contractName'] === 'UKG HYN'
                        ? {
                            background: 'primary',
                            color: 'black'
                        } : drItem['contractName'] === 'Collections'
                            ? { background: '#558ce7' } : drItem['contractName'] === 'Greater Of w/HYN'
                                ? {
                                    background: '#07036B',
                                    color: '#ffffff'
                                } : drItem['contractName'] === 'Sum Of w/HYN'
                                    ? {
                                        background: 'primary',
                                        color: '#d67d38'
                                    } : drItem['contractName'] === 'Collections w/HYN'
                                        ? { background: '#558ce7' } : drItem['contractName'] === 'GOX w/HYN'
                                            ? { background: '5FE47F' } : { background: 'grey' };
}

exports.getDoctorListOptions = (user, altPayOnly = false) => {
    let drListOptions = [];
    let drListOptionsUserIds = [];

    if (user && user.drList) {
        const listIndices = dentistTypes;

        listIndices.forEach(index => {
            const drList = user.drList[index];
            if (drList && Object.keys(drList).length) {
                Object.keys(drList).forEach(abbr => {
                    const drItem = drList[abbr];
                    if (!drListOptionsUserIds.includes(drItem.userId)
                        && abbr !== 'null'
                        && (!altPayOnly || drItem.altPay)) {
                        drListOptionsUserIds.push(drItem.userId);
                        const customStyle = getCustomStyle(drItem);
                        drListOptions.push({
                            key: (abbr && abbr !== 'null') ? abbr : drItem['firstName'],
                            value: abbr,
                            text: `${drItem['firstName']} ${drItem['lastName']}(${abbr ? abbr : ""})`,
                            title: drItem['lastName'],
                            style: customStyle
                        });
                    }
                });
            }
        });

        drListOptions = _.sortBy(drListOptions, ['title']);
    }

    return drListOptions;
}
